/**
 * @fileoverview Area data source and type definitions.
 */

import { AreaSchema, type Area } from '@schema/index';
import { createBaseDataSource } from './base-data-source';
import { createArchivedAtField, createAccountTrackingFields, createCreatedAtField, createDeletedAtField, createLookupEntityFields, createUpdatedAtField } from './field-factories';
import { getCache } from './cache-registry';

export type { Area };

export const areaDataSource = createBaseDataSource<Area>({
  endpoint: 'area',
  searchField: 'name',
  schema: AreaSchema,
  fields: [
    ...createLookupEntityFields(),
    ...createAccountTrackingFields({ includeArchived: true }),
    createArchivedAtField(),
    createCreatedAtField(),
    createUpdatedAtField(),
    createDeletedAtField(),
  ],
});

export const areaCache = getCache('area');
